module.exports = __webpack_public_path__ + "static/img/loongDance_share.5add067.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/loongDance_share.jpg
// module id = xeEL
// module chunks = 26